angular.module('hcap-analytics').controller('DashboardCtrl', [
  '$scope',
  '$location',
  '$state',
  'SweetAlert',
  'PortalSectionService',
  'CohortsService',
function(
  $scope,
  $location,
  $state,
  SweetAlert,
  PortalSectionService,
  CohortsService,
) {
  const portal = $state.params.portal || 'v2';

  $scope.sectionVisibility = {
    self: false,
    leader: false,
    rel: false,
    moral: false,
  };
  $scope.showOrganization = PortalSectionService.showOrganization(portal);
  $scope.showTeamsModule = PortalSectionService.showTeamsModule(portal);

  CohortsService.getLatestAssessmentAccess(portal).then(function(access) {
    const allowedAssessmentIds = access.assessments ? access.assessments.map(a => a.assessmentId) : null;

    $scope.sectionVisibility = {
      self: PortalSectionService.hasSidebarSection(portal, 'self', allowedAssessmentIds),
      leader: PortalSectionService.hasSidebarSection(portal, 'leader', allowedAssessmentIds),
      rel: PortalSectionService.hasSidebarSection(portal, 'rel', allowedAssessmentIds),
      moral: PortalSectionService.hasSidebarSection(portal, 'moral', allowedAssessmentIds),
    };
  });

  const welcomeText = portal === 'CSM' ?
    `Welcome to Hcap Analytics! You may access the assessments in each module via the dashboard on the navigation panel to the left.

We invite first time users to begin in the Self Leadership module, completing HEXACO@Work Personality Profile and Emotional Intelligence. Next, explore Hcap capabilities such as Leading with Virtue.

Welcome again! We hope you enjoy the empowering experience of purposefully developing and showcasing your human capital at work!` :
    `Welcome to Hcap Analytics! You may access the assessments in each module via the dashboard on the navigation panel to the left.

We invite first time users to begin in the Self Leadership module, completing popular assessments such as HEXACO Personality Profile and Emotional Intelligence. Next, explore other Hcap capabilities such as Conflict Management Style, Procrastination, and Leading Others.

Welcome again! We hope you enjoy the empowering experience of purposefully developing and showcasing your human capital at work!`;

  const welcomePopup = () => {
    const firstVisit = localStorage.getItem('firstVisit');
    $scope.welcome = firstVisit !== null ? JSON.parse(firstVisit) : true;

    if ($scope.welcome) {
      localStorage.setItem('firstVisit', false);

      SweetAlert.swal({
        type: 'info',
        customClass: 'welcome-alert',
        title: '',
        text: welcomeText,
      });
      setTimeout(() => {
        document.querySelector('.sweet-alert').scrollTop = 0;
      }, 50);
    }
  };

  const parser = new UAParser();
  const parseResult = parser.getResult();

  if (!parseResult.browser.name.match(/chrome|firefox/ig)) {
    SweetAlert.swal({
      type: '',
      customClass: 'browser-alert',
      title: 'Unsupported Browser Detected',
      text: `Unsupported browser detected or unable to determine browser.

      Please use Chrome or Firefox`,
    }, () => {
      setTimeout(() => {
        welcomePopup();
      }, 500);
    });
  } else {
    welcomePopup();
  }
}]);
